(() => {
  if (customElements.get('bp-results-carousel')) return;
  customElements.define('bp-results-carousel', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      const track = this.querySelector('[data-results-track]');
      const cards = [...this.querySelectorAll('.bp2-bacard')];
      const dots = [...this.querySelectorAll('[data-results-dot]')];
      const previous = this.querySelector('[data-results-prev]');
      const next = this.querySelector('[data-results-next]');
      const status = this.querySelector('[data-results-status]');
      if (!track || !cards.length || !previous || !next) return;
      const controller = new AbortController();
      this.controller = controller;
      const options = {signal: controller.signal};
      const mobile = matchMedia('(max-width:1100px)');
      const reduced = matchMedia('(prefers-reduced-motion:reduce)');
      let active = -1;
      const update = () => {
        const edge = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft);
        let closest = 0;
        cards.forEach((card, index) => {
          if (Math.abs(card.getBoundingClientRect().left - edge) < Math.abs(cards[closest].getBoundingClientRect().left - edge)) closest = index;
        });
        if (closest !== active) {
          active = closest;
          dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
          status.textContent = `Comparison ${active + 1} of ${cards.length}`;
        }
        previous.disabled = active === 0;
        next.disabled = active === cards.length - 1;
        this.toggleAttribute('data-at-end', active === cards.length - 1);
        track.tabIndex = mobile.matches ? 0 : -1;
      };
      const go = index => {
        const card = cards[Math.max(0, Math.min(cards.length - 1, index))];
        const left = track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left - parseFloat(getComputedStyle(track).paddingLeft);
        track.scrollTo({left, behavior: reduced.matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => go(active - 1), options);
      next.addEventListener('click', () => go(active + 1), options);
      dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), options));
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(update);
      }, {...options, passive:true});
      track.addEventListener('keydown', event => {
        if (!mobile.matches) return;
        const destination = {ArrowLeft:active - 1, ArrowRight:active + 1, Home:0, End:cards.length - 1}[event.key];
        if (destination === undefined) return;
        event.preventDefault();
        go(destination);
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      this.setAttribute('data-ready', '');
      update();
    }
    cleanup() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    disconnectedCallback() { this.cleanup(); }
  });
})();
